import React from 'react'
import {Grid} from "@mui/material"
import {ReactComponent as NewWindowIcon} from "src/v2/assets/icons/new-windows-icon.svg"
import {ReactComponent as EyeOpenIcon} from "src/v2/assets/icons/eye-open.svg"
import {renderCellDateTime} from "../../../../utils/table-render-functions"
import ButtonWithIcon from "../../../components/Button/Button"

const renderDuplicarButton = (params, onDuplicar) => (
    <Grid container spacing={2}>
        <Grid item>
            <ButtonWithIcon icon={<NewWindowIcon/>} onClick={() => {
                onDuplicar(params.row)
            }}>DUPLICAR</ButtonWithIcon>
        </Grid>
    </Grid>
)

const renderVerButton = (params, onVer) => (
    <ButtonWithIcon icon={<EyeOpenIcon/>} onClick={() => onVer?.(params.row)}>VER</ButtonWithIcon>
)

export const createColumnsCadastroEventosMotor = (onVer, onDuplicar) => [
    {field: "CETIP", headerName: "CETIP", minWidth: 150, flex: 1},
    {
        field: "ver",
        sortable: false,
        disableColumnMenu: true,
        headerName: "",
        minWidth: 120,
        renderCell: (params) => renderVerButton(params, onVer),
    },
    {field: "VersaoDocumento", headerName: "VER. DOC", minWidth: 70, flex: 1},
    {field: "Status", headerName: "STATUS", minWidth: 200, flex: 1},
    {field: "Usuario", headerName: "USUÁRIO", minWidth: 200, flex: 1},
    {
        field: "CriadoEm",
        headerName: "DATA CRIAÇÃO",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "AtualizadoEm",
        headerName: "ÚLTIMA ATUALIZAÇÃO",
        minWidth: 200,
        flex: 1,
        renderCell: (params) => renderCellDateTime(params)
    },
    {
        field: "acoes",
        sortable: false,
        disableColumnMenu: true,
        headerName: "",
        minWidth: 200,
        renderCell: (params) => renderDuplicarButton(params, onDuplicar),
    },
]
